import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '../../../ui/gridSystem';
import { CTA, CustomSelect, Text } from '../../../ui/atoms';
import Tabs from '../../../ui/atoms/Tabs';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import { TabContent, TabsWrapper, TabsWrapperMobile } from './style';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import {
  COURSE_CANCEL,
  COURSE_TAB_SAVE,
  SECTIONS_SET,
  REDUCED_TABS_SET,
  TUTOR_ACTIVE_TAB_SET,
  TABS_RESET,
  TUTOR_DISABLED_TAB_SET,
} from '../../redux/actions/tutors';
import ModalCancelCourse, {
  ModalCancelCourseId,
} from '../../../ui/atoms/Modals/ModalCancelCourse';
import { MODAL_OPEN } from '../../redux/actions';
import { UPDATE_COURSE_DETAILS_GET } from '../../redux/actions/tutorCourseList';
import routes from '../../../routes';
import theme from '../../../ui/theme';
import ModalCategoryMedia from '../../../ui/atoms/Modals/ModalCategoryMedia';
import Overview from './Overview';
import Sessions from './Sessions';
import Documents from './Documents';
import Registration from './Registration';

const allTabsActive = {};
[1, 2, 3, 4].forEach(
  (i) =>
    (allTabsActive[i] = {
      completed: true,
      disabled: false,
      subLabel: 'Revisiona',
      subIcon: 'edit-04',
    })
);

const PreviewEvent = ({
  mediaIsPhone,
  tabs,
  activeTabValue,
  details,
  permissions,
  storeActiveTab,
  modalOpen,
  getCourseDetails,
  courseCancel,
  courseTabSave,
  sectionsSet,
  reducedTabsSet,
  tabsReset,
  setDisabledTab,
}) => {
  const navigate = useNavigate();
  const { event_id } = useParams();
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    getCourseDetails(event_id, navigate);
    setActiveTab(tabs[0]);
    storeActiveTab(1);
    setFirstRender(false);
    setDisabledTab(allTabsActive);
    return () => {
      courseCancel();
      tabsReset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event_id]);

  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      // console.log('+++ DETAILS +++', details);
      // save overview data
      courseTabSave({
        tabName: 'overview',
        data: {
          participation_percentage: Number(details?.event_min_percentage),
          allow_comments: details?.allow_comments,
          category: details?.category,
          subject: details?.subject,
          code: details?.code,
          course_cover: details?.course_cover,
          description: details?.description,
          level: details?.level,
          panoramic_media: details?.panoramic_media,
          published: details?.published,
          related_courses: details?.related_courses || [],
          tags: details?.tags,
          title: details?.title,
        },
        editMode: true,
      });
      // save activity data
      const newSections = {};
      let actCount = 0;
      (details?.session || []).forEach((s, i) => {
        const newActivities = {};
        // add activities (sessions) data
        (s?.activities || []).forEach((a, ai) => {
          actCount = Math.max(actCount, a.id);
          newActivities[a.id] = {
            order: a?.type === 'activity_quiz' ? 999 : ai,
            type: a?.type,
            data: { ...a },
          };
        });
        // add quiz data
        if (s?.session_quiz_id) {
          newActivities[details.session.session_quiz_id] = {
            order: 999,
            type: 'activity_quiz',
            data: {
              ...(s?.quiz_data || {}),
              nid: s?.session_quiz_id,
              quiz_tentatives: s?.session_quiz_tentatives,
              percentage: s?.quiz_data?.min_perc_to_pass,
            },
          };
        }
        newSections[i + 1] = {
          title: s?.session_name,
          activities: newActivities,
        };
      });
      courseTabSave({
        tabName: 'activities',
        data: {
          sections: newSections,
        },
      });
      sectionsSet({
        secCount: details?.sections?.length,
        actCount,
        sections: newSections,
      });
      // save documents data
      courseTabSave({
        tabName: 'documents',
        data: (details?.inner_documents || []).map((d) => d.id),
      });
      // save registration data
      courseTabSave({
        tabName: 'registration',
        data: {
          mandatory_ffoo_ids: (details?.mandatory_ffoo || []).map(
            (fo) => fo.id
          ),
          included_groups: (details?.included_groups || []).map((g) => g.id),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  useEffect(() => {
    if (!firstRender) storeActiveTab(activeTab.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab?.value]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    if (!firstRender) {
      setActiveTab(tabs.find((t) => t?.value === activeTabValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabValue]);

  return (
    <>
      <Breadcrumb
        crumbs={[
          {
            label: 'Gestione percorsi formativi',
            onClick: () => navigate(routes.tutorCourseList.path),
          },
          {
            label: 'Gestione richieste di approvazione',
            onClick: () => navigate(routes.approvalList.path),
          },
          { label: `Revisione percorso formativo: ${details?.title}` },
        ]}
      />
      <Container className="pt-0">
        <div className={mediaIsPhone ? '' : 'd-flex sb mb-2'}>
          <Text type="h1" mb={mediaIsPhone ? 8 : 0}>
            Revisione percorso formativo
          </Text>
          <CTA
            type="tertiary"
            btnText="ESCI DALLA MODALITà DI REVISIONE"
            onClick={() => modalOpen(ModalCancelCourseId)}
            icon="x-close"
          />
        </div>
        <Text type="h1.5" color={theme().colors.textSecondary} mb={8}>
          Evento:
        </Text>
        <Text type="h2" color={theme().colors.textSecondary}>
          {details?.title}
        </Text>
        {mediaIsPhone ? (
          <TabsWrapperMobile>
            <Text type="h3">{activeTab?.label}</Text>
            <CustomSelect
              options={tabs.map((t) => ({
                label: `${t.value}/${tabs?.length}`,
                value: t.value,
                isDisabled: t?.disabled,
              }))}
              placeholder={`1/${tabs?.length}`}
              onChange={({ value }) =>
                setActiveTab(tabs.find((t) => t.value === value))
              }
              selected={{
                label: `${activeTab?.value || tabs?.length}/${tabs?.length}`,
                value: activeTab?.value,
              }}
              value={`${activeTab?.value || tabs?.length}/${tabs?.length}`}
            />
          </TabsWrapperMobile>
        ) : (
          <TabsWrapper>
            <Tabs
              tabs={tabs}
              onChange={(t) => {
                setActiveTab(t);
              }}
              selected={activeTab}
              tabType="tertiary"
              showNumbers
              fullWidth
            />
          </TabsWrapper>
        )}
        <TabContent className={activeTab?.value === 1 ? 'active' : ''}>
          <Overview />
        </TabContent>
        <TabContent className={activeTab?.value === 2 ? 'active' : ''}>
          <Sessions />
        </TabContent>
        <TabContent className={activeTab?.value === 3 ? 'active' : ''}>
          <Documents />
        </TabContent>
        <TabContent className={activeTab?.value === 4 ? 'active' : ''}>
          <Registration />
        </TabContent>
        <ModalCancelCourse />
        <ModalCategoryMedia />
      </Container>
    </>
  );
};

PreviewEvent.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  tabs: PropTypes.array.isRequired,
  activeTabValue: PropTypes.number,
  details: PropTypes.object,
  permissions: PropTypes.array,
  // HOC: dispatch
  storeActiveTab: PropTypes.func,
  modalOpen: PropTypes.func,
  courseCancel: PropTypes.func,
  getCourseDetails: PropTypes.func,
  courseTabSave: PropTypes.func,
  sectionsSet: PropTypes.func,
  reducedTabsSet: PropTypes.func,
  tabsReset: PropTypes.func,
  setDisabledTab: PropTypes.func,
};

export default connect(
  (state) => {
    const { tabs, activeTab: activeTabValue } = state.tutors;
    const { details } = state.tutorCourseList;
    const { course: permissions } = state.permissions;
    return {
      tabs,
      activeTabValue,
      details,
      permissions,
    };
  },
  (dispatch) => ({
    setDisabledTab: (tabs) => dispatch({ type: TUTOR_DISABLED_TAB_SET, tabs }),
    reducedTabsSet: () => dispatch({ type: REDUCED_TABS_SET }),
    storeActiveTab: (tab) => dispatch({ type: TUTOR_ACTIVE_TAB_SET, tab }),
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    courseCancel: () => dispatch({ type: COURSE_CANCEL._REQUEST }),
    getCourseDetails: (id, navigate) =>
      dispatch({ type: UPDATE_COURSE_DETAILS_GET._REQUEST, id, navigate }),
    courseTabSave: ({ tabName, data, editMode }) =>
      dispatch({ type: COURSE_TAB_SAVE, tabName, data, editMode }),
    sectionsSet: ({ secCount, actCount, sections }) =>
      dispatch({ type: SECTIONS_SET, secCount, actCount, sections }),
    tabsReset: () => dispatch({ type: TABS_RESET }),
  })
)(withMediaQueries(PreviewEvent));
